import SubstackEmbed from "@/components/site/SubstackEmbed";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen pt-20 lg:pt-28 overflow-hidden"
    >
      {/* BG image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/14332267/pexels-photo-14332267.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/75 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/60" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 lg:pt-24 pb-24 lg:pb-32 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-8 fade-up">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-1.5 h-1.5 bg-[#d92d20] animate-pulse" />
            <span className="overline overline-red">Crisis Leadership · Organizational Resilience</span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display font-extrabold text-[44px] sm:text-[64px] lg:text-[88px] xl:text-[104px] leading-[0.92] tracking-[-0.035em]"
          >
            Most organizations
            <br />
            {"don't fail during"}
            <br />
            the crisis. They fail
            <br />
            <span className="text-[#d92d20]">long before it.</span>
          </h1>

          <p className="mt-10 max-w-2xl text-base sm:text-lg text-white/70 leading-relaxed">
            Dr. Cj Avory helps leaders in government, healthcare, higher education,
            and public safety build the decision margin to perform when conditions
            become uncertain.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-6 items-start">
            <SubstackEmbed testId="hero-substack" />
            <a
              href="#book"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center justify-center gap-3 border border-[#404040] hover:border-white text-white px-7 py-4 text-[12px] font-semibold tracking-[0.18em] uppercase transition-colors"
            >
              Read the Book
            </a>
          </div>
        </div>

        <div className="lg:col-span-4 lg:pt-10">
          <div className="border-l border-[#262626] pl-6 lg:pl-8 space-y-8">
            <Stat number="20+" label="Years in emergency management, public safety, and crisis response" />
            <Stat number="Author" label="Of Decision Margin — Why Organizations Fail Before the Crisis Hits" />
            <Stat number="DM" label="Doctor of Management in Homeland Security" />
          </div>
        </div>
      </div>

      {/* Bottom strip */}
      <div className="relative border-t border-[#262626] bg-black/60 backdrop-blur-sm">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex items-center justify-between text-[11px] font-mono uppercase tracking-[0.22em] text-white/50">
          <span>EM · Public Safety · Resilience</span>
          <span className="hidden sm:inline">Scroll ↓</span>
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label }) {
  return (
    <div>
      <div className="bignum text-4xl lg:text-5xl text-white">{number}</div>
      <div className="mt-2 text-xs text-white/60 leading-snug max-w-[220px]">{label}</div>
    </div>
  );
}
